<template>
  <div>
    <!--子导航-->
    <Row type="flex" :space-x="10" class="margin-right-left padding-top" align="middle">
      <Cell>
        <Radio type="button" v-model="active" :datas="navDatas" @change="onTab"></Radio>
      </Cell>
    </Row>

    <div class="h-panel-body padding-top">
      <!--1.存货管理-->
      <div v-if="active === 'material'">
        <Row type="flex" :space-x="10" class="margin-bottom" align="middle">
          <Cell><Button color="primary" @click="openMaterial">新增存货</Button></Cell>
          <Cell><Button @click="importMaterial">导入</Button><input ref="fileInput" type="file" accept=".csv" style="display:none" @change="onFile"></Cell>
          <Cell><Button @click="exportMaterial">导出</Button></Cell>
          <Cell><Button @click="downloadTemplate">下载模板</Button></Cell>
        </Row>
        <Table :datas="materials" :border="true" :loading="loading.material">
          <TableItem title="编码" prop="code" :width="110"></TableItem>
          <TableItem title="名称" prop="name" :width="150"></TableItem>
          <TableItem title="存货类别" :width="110">
            <template slot-scope="{data}">{{ categoryName(data.categoryId) }}</template>
          </TableItem>
          <TableItem title="规格型号" prop="spec" :width="110"></TableItem>
          <TableItem title="计量单位" :width="90">
            <template slot-scope="{data}">{{ data.unit || unitName(data.unitId) }}</template>
          </TableItem>
          <TableItem title="库存数量" prop="stockQty" align="right" :width="100"></TableItem>
          <TableItem title="启用日期" prop="enableDate" :width="110"></TableItem>
          <TableItem title="停用日期" prop="stopDate" :width="110"></TableItem>
          <TableItem title="状态" :width="80" align="center">
            <template slot-scope="{data}">
              <Tag :color="data.status === 0 ? 'default' : 'success'">{{ data.status === 0 ? '停用' : '启用' }}</Tag>
            </template>
          </TableItem>
          <TableItem title="操作" :width="110" align="center">
            <span slot-scope="{data}" class="link" @click="openMaterial(data)">编辑</span>
            <span slot-scope="{data}" class="link danger" @click="removeMaterial(data)">删除</span>
          </TableItem>
        </Table>
      </div>

      <!--2.单据类型-->
      <div v-if="active === 'billType'">
        <Row class="margin-bottom"><Button color="primary" @click="openBillType">新增单据类型</Button></Row>
        <Table :datas="billTypes" :border="true">
          <TableItem title="编码" prop="code" :width="100"></TableItem>
          <TableItem title="名称" prop="name" :width="150"></TableItem>
          <TableItem title="业务类型" prop="bizType" :width="110"></TableItem>
          <TableItem title="方向" :width="80" align="center">
            <template slot-scope="{data}">
              <Tag :color="data.direction === 'OUT' ? 'warning' : 'success'">{{ data.direction === 'OUT' ? '出库' : '入库' }}</Tag>
            </template>
          </TableItem>
          <TableItem title="凭证字" prop="voucherWord" :width="100"></TableItem>
          <TableItem title="备注" prop="remark"></TableItem>
          <TableItem title="状态" :width="80" align="center">
            <template slot-scope="{data}">
              <Tag :color="data.status === 0 ? 'default' : 'success'">{{ data.status === 0 ? '停用' : '启用' }}</Tag>
            </template>
          </TableItem>
          <TableItem title="操作" :width="110" align="center">
            <span slot-scope="{data}" class="link" @click="openBillType(data)">编辑</span>
            <span slot-scope="{data}" class="link danger" @click="removeBillType(data)">删除</span>
          </TableItem>
        </Table>
      </div>

      <!--3.计量单位-->
      <div v-if="active === 'unit'">
        <Row class="margin-bottom"><Button color="primary" @click="openUnit">新增计量单位</Button></Row>
        <Table :datas="units" :border="true">
          <TableItem title="编码" prop="code" :width="120"></TableItem>
          <TableItem title="名称" prop="name" :width="160"></TableItem>
          <TableItem title="备注" prop="remark"></TableItem>
          <TableItem title="状态" :width="80" align="center">
            <template slot-scope="{data}">
              <Tag :color="data.status === 0 ? 'default' : 'success'">{{ data.status === 0 ? '停用' : '启用' }}</Tag>
            </template>
          </TableItem>
          <TableItem title="操作" :width="110" align="center">
            <span slot-scope="{data}" class="link" @click="openUnit(data)">编辑</span>
            <span slot-scope="{data}" class="link danger" @click="removeUnit(data)">删除</span>
          </TableItem>
        </Table>
      </div>

      <!--4.存货科目映射-->
      <div v-if="active === 'mapping'">
        <Row class="margin-bottom"><Button color="primary" @click="openMapping">新增映射</Button></Row>
        <Table :datas="mappings" :border="true">
          <TableItem title="映射类型" :width="100" align="center">
            <template slot-scope="{data}">
              <Tag>{{ data.mappingType === 2 ? '类别' : '存货' }}</Tag>
            </template>
          </TableItem>
          <TableItem title="存货/类别" prop="targetName" :width="180"></TableItem>
          <TableItem title="科目" :width="200">
            <template slot-scope="{data}">{{ subjectName(data.subjectId) }}</template>
          </TableItem>
          <TableItem title="方向" :width="90" align="center">
            <template slot-scope="{data}">{{ data.direction === 2 ? '贷方' : '借方' }}</template>
          </TableItem>
          <TableItem title="操作" :width="110" align="center">
            <span slot-scope="{data}" class="link" @click="openMapping(data)">编辑</span>
            <span slot-scope="{data}" class="link danger" @click="removeMapping(data)">删除</span>
          </TableItem>
        </Table>
      </div>

      <!--5.规则配置-->
      <div v-if="active === 'rule'" style="max-width:640px">
        <h3>单据编号规则</h3>
        <Form label-width="120" :model="numberRule">
          <FormItem label="入库单前缀"><input type="text" v-model="numberRule.inPrefix"></FormItem>
          <FormItem label="出库单前缀"><input type="text" v-model="numberRule.outPrefix"></FormItem>
          <FormItem label="日期格式">
            <Select v-model="numberRule.datePattern" style="width:180px">
              <Option value="yyyyMMdd">yyyyMMdd</Option>
              <Option value="yyMMdd">yyMMdd</Option>
              <Option value="">不使用日期</Option>
            </Select>
          </FormItem>
          <FormItem label="序号位数"><input type="number" v-model.number="numberRule.seqLength" min="2" max="8"></FormItem>
        </Form>
        <h3>核算配置</h3>
        <Form label-width="120" :model="moduleConfig">
          <FormItem label="成本核算方法">
            <Select v-model="moduleConfig.costMethod" style="width:180px">
              <Option value="weightedAvg">移动加权平均</Option>
              <Option value="fifo">先进先出</Option>
            </Select>
          </FormItem>
          <FormItem label="允许负库存">
            <HSwitch v-model="moduleConfig.negativeStockAllowed"></HSwitch>
          </FormItem>
          <FormItem label="单据自动生成凭证">
            <HSwitch v-model="moduleConfig.autoVoucher"></HSwitch>
          </FormItem>
        </Form>
        <Button color="primary" @click="saveRule">保存配置</Button>
      </div>
    </div>

    <!--存货编辑弹窗-->
    <Modal v-model="modal.material" :title="materialForm.id ? '编辑存货' : '新增存货'" width="640">
      <Form label-width="100" :model="materialForm">
        <FormItem label="编码"><input type="text" v-model="materialForm.code" style="width:100%"></FormItem>
        <FormItem label="名称"><input type="text" v-model="materialForm.name" style="width:100%"></FormItem>
        <FormItem label="存货类别">
          <Select v-model="materialForm.categoryId" filterable :allow-clear="true">
            <Option v-for="c in categories" :value="c.id" :key="c.id">{{ c.name }}</Option>
          </Select>
        </FormItem>
        <FormItem label="规格型号"><input type="text" v-model="materialForm.spec" style="width:100%"></FormItem>
        <FormItem label="计量单位">
          <Select v-model="materialForm.unitId" filterable :allow-clear="true" @change="onUnitPick">
            <Option v-for="u in units" :value="u.id" :key="u.id">{{ u.name }}</Option>
          </Select>
        </FormItem>
        <FormItem label="对应科目">
          <Select v-model="materialForm.subjectId" filterable :allow-clear="true">
            <Option v-for="s in subjectOptions" :value="s.id" :key="s.id">{{ s.code }}-{{ s.name }}</Option>
          </Select>
        </FormItem>
        <FormItem label="启用日期"><DatePicker v-model="materialForm.enableDate" format="yyyy-MM-dd"></DatePicker></FormItem>
        <FormItem label="停用日期"><DatePicker v-model="materialForm.stopDate" format="yyyy-MM-dd"></DatePicker></FormItem>
        <FormItem label="状态">
          <HSwitch v-model="materialEnabled" @change="v => materialForm.status = v ? 1 : 0"></HSwitch>
        </FormItem>
      </Form>
      <div slot="bottom">
        <Button @click="modal.material = false">取消</Button>
        <Button color="primary" @click="saveMaterial">保存</Button>
      </div>
    </Modal>

    <!--单据类型弹窗-->
    <Modal v-model="modal.billType" title="单据类型" width="560">
      <Form label-width="100" :model="billTypeForm">
        <FormItem label="编码"><input type="text" v-model="billTypeForm.code" style="width:100%"></FormItem>
        <FormItem label="名称"><input type="text" v-model="billTypeForm.name" style="width:100%"></FormItem>
        <FormItem label="业务类型"><input type="text" v-model="billTypeForm.bizType" style="width:100%"></FormItem>
        <FormItem label="方向">
          <Radio type="button" v-model="billTypeForm.direction" :datas="[{key:'IN',title:'入库'},{key:'OUT',title:'出库'}]"></Radio>
        </FormItem>
        <FormItem label="凭证字">
          <Select v-model="billTypeForm.voucherWord" filterable :allow-clear="true">
            <Option v-for="w in voucherWords" :value="w.word" :key="w.id">{{ w.word }}</Option>
          </Select>
        </FormItem>
        <FormItem label="备注"><input type="text" v-model="billTypeForm.remark" style="width:100%"></FormItem>
      </Form>
      <div slot="bottom">
        <Button @click="modal.billType = false">取消</Button>
        <Button color="primary" @click="saveBillType">保存</Button>
      </div>
    </Modal>

    <!--计量单位弹窗-->
    <Modal v-model="modal.unit" title="计量单位" width="480">
      <Form label-width="90" :model="unitForm">
        <FormItem label="编码"><input type="text" v-model="unitForm.code" style="width:100%"></FormItem>
        <FormItem label="名称"><input type="text" v-model="unitForm.name" style="width:100%"></FormItem>
        <FormItem label="备注"><input type="text" v-model="unitForm.remark" style="width:100%"></FormItem>
      </Form>
      <div slot="bottom">
        <Button @click="modal.unit = false">取消</Button>
        <Button color="primary" @click="saveUnit">保存</Button>
      </div>
    </Modal>

    <!--科目映射弹窗-->
    <Modal v-model="modal.mapping" title="存货科目映射" width="560">
      <Form label-width="100" :model="mappingForm">
        <FormItem label="映射类型">
          <Radio type="button" v-model="mappingForm.mappingType" :datas="[{key:1,title:'存货'},{key:2,title:'类别'}]"></Radio>
        </FormItem>
        <FormItem label="存货/类别">
          <Select v-model="mappingForm.targetId" filterable>
            <Option v-if="mappingForm.mappingType === 2" v-for="c in categories" :value="c.id" :key="c.id">{{ c.name }}</Option>
            <Option v-else v-for="m in materials" :value="m.id" :key="m.id">{{ m.name }}</Option>
          </Select>
        </FormItem>
        <FormItem label="会计科目">
          <Select v-model="mappingForm.subjectId" filterable>
            <Option v-for="s in subjectOptions" :value="s.id" :key="s.id">{{ s.code }}-{{ s.name }}</Option>
          </Select>
        </FormItem>
        <FormItem label="方向">
          <Radio type="button" v-model="mappingForm.direction" :datas="[{key:1,title:'借方'},{key:2,title:'贷方'}]"></Radio>
        </FormItem>
      </Form>
      <div slot="bottom">
        <Button @click="modal.mapping = false">取消</Button>
        <Button color="primary" @click="saveMapping">保存</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  name: 'InventoryBasicSetting',
  data() {
    return {
      active: 'material',
      navDatas: [
        {key: 'material', title: '存货管理'},
        {key: 'billType', title: '单据类型'},
        {key: 'unit', title: '计量单位'},
        {key: 'mapping', title: '存货科目映射'},
        {key: 'rule', title: '规则配置'}
      ],
      loading: {material: false},
      materials: [],
      categories: [],
      units: [],
      billTypes: [],
      mappings: [],
      voucherWords: [],
      subjectOptions: [],
      numberRule: {},
      moduleConfig: {},
      modal: {material: false, billType: false, unit: false, mapping: false},
      materialForm: {},
      billTypeForm: {},
      unitForm: {},
      mappingForm: {}
    };
  },
  computed: {
    materialEnabled() {
      return this.materialForm.status !== 0;
    }
  },
  methods: {
    onTab() {},
    // ---------- 通用加载 ----------
    loadAll() {
      this.loadMaterials();
      this.$api.pro.inventory.categoryList().then(({data}) => { this.categories = data || []; }).catch(() => {});
      this.$api.pro.inventory.unitList().then(({data}) => { this.units = data || []; }).catch(() => {});
      this.$api.pro.inventory.billTypeList().then(({data}) => { this.billTypes = data || []; }).catch(() => {});
      this.$api.pro.inventory.mappingList().then(({data}) => { this.mappings = data || []; }).catch(() => {});
      this.$api.setting.voucherWord.list().then(({data}) => { this.voucherWords = data || []; }).catch(() => {});
      this.$api.setting.subject.allList().then(({data}) => {
        this.subjectOptions = this.flattenSubjects(data || []);
      }).catch(() => {});
      this.$api.pro.inventory.numberRule().then(({data}) => { this.numberRule = data || {}; }).catch(() => {});
      this.$api.pro.inventory.config().then(({data}) => { this.moduleConfig = data || {}; }).catch(() => {});
    },
    flattenSubjects(nodes, out = []) {
      (nodes || []).forEach(n => {
        if (n.id) {
          out.push({id: n.id, code: n.code, name: n.name});
        }
        if (n.children && n.children.length) {
          this.flattenSubjects(n.children, out);
        }
      });
      return out;
    },
    loadMaterials() {
      this.loading.material = true;
      this.$api.pro.inventory.stocks({pageSize: 1000}).then(({data}) => {
        this.materials = data.results || data || [];
      }).finally(() => this.loading.material = false);
    },
    categoryName(id) {
      let c = this.categories.find(x => x.id === id);
      return c ? c.name : '';
    },
    unitName(id) {
      let u = this.units.find(x => x.id === id);
      return u ? u.name : '';
    },
    subjectName(id) {
      let s = this.subjectOptions.find(x => x.id === id);
      return s ? s.code + '-' + s.name : '';
    },
    // ---------- 存货 ----------
    openMaterial(data) {
      this.materialForm = data ? Object.assign({}, data)
        : {code: '', name: '', categoryId: null, spec: '', unitId: null, subjectId: null, status: 1, enableDate: null, stopDate: null};
      this.modal.material = true;
    },
    onUnitPick(id) {
      this.materialForm.unit = this.unitName(id);
    },
    saveMaterial() {
      if (!this.materialForm.name) {
        this.$Message.warning('请填写名称');
        return;
      }
      this.$api.pro.inventory.stockSave(this.materialForm).then(() => {
        this.$Message.success('保存成功');
        this.modal.material = false;
        this.loadMaterials();
      });
    },
    removeMaterial(data) {
      this.$Confirm(`确认删除存货 ${data.name}？`).then(() => {
        this.$api.setting.inventoryMaterial.delete(data.id).then(() => {
          this.$Message.success('删除成功');
          this.loadMaterials();
        });
      });
    },
    downloadTemplate() {
      this.download('存货模板.csv', '编码,名称,类别,规格型号,计量单位,科目编码,启用日期\n');
    },
    exportMaterial() {
      let lines = this.materials.map(m => [m.code, m.name, this.categoryName(m.categoryId), m.spec, m.unit || this.unitName(m.unitId), '', m.enableDate]);
      let csv = [['编码', '名称', '类别', '规格型号', '计量单位', '科目编码', '启用日期']].concat(lines)
        .map(a => a.map(v => `"${String(v == null ? '' : v).replace(/"/g, '""')}"`).join(',')).join('\n');
      this.download('存货档案.csv', csv);
    },
    importMaterial() {
      this.$refs.fileInput.value = '';
      this.$refs.fileInput.click();
    },
    onFile(e) {
      let file = e.target.files[0];
      if (!file) {
        return;
      }
      let reader = new FileReader();
      reader.onload = () => {
        let text = String(reader.result).replace(/^\ufeff/, '');
        let rows = text.split(/\r?\n/).filter(l => l.trim()).slice(1);
        let tasks = rows.map(line => {
          let c = line.split(',').map(x => x.replace(/^"|"$/g, '').trim());
          return this.$api.pro.inventory.stockSave({
            code: c[0], name: c[1], spec: c[3], unit: c[4], status: 1
          });
        });
        Promise.all(tasks).then(() => {
          this.$Message.success(`成功导入 ${tasks.length} 条`);
          this.loadMaterials();
        });
      };
      reader.readAsText(file, 'utf-8');
    },
    // ---------- 单据类型 ----------
    openBillType(data) {
      this.billTypeForm = data ? Object.assign({}, data)
        : {code: '', name: '', bizType: '', direction: 'IN', voucherWord: '', remark: '', status: 1};
      this.modal.billType = true;
    },
    saveBillType() {
      if (!this.billTypeForm.name) {
        this.$Message.warning('请填写名称');
        return;
      }
      this.$api.pro.inventory.billTypeSave(this.billTypeForm).then(() => {
        this.$Message.success('保存成功');
        this.modal.billType = false;
        this.$api.pro.inventory.billTypeList().then(({data}) => { this.billTypes = data || []; });
      });
    },
    removeBillType(data) {
      this.$Confirm('确认删除该单据类型？').then(() => {
        this.$api.pro.inventory.billTypeDel(data.id).then(() => {
          this.billTypes = this.billTypes.filter(x => x.id !== data.id);
        });
      });
    },
    // ---------- 计量单位 ----------
    openUnit(data) {
      this.unitForm = data ? Object.assign({}, data) : {code: '', name: '', remark: '', status: 1};
      this.modal.unit = true;
    },
    saveUnit() {
      if (!this.unitForm.name) {
        this.$Message.warning('请填写名称');
        return;
      }
      this.$api.pro.inventory.unitSave(this.unitForm).then(() => {
        this.$Message.success('保存成功');
        this.modal.unit = false;
        this.$api.pro.inventory.unitList().then(({data}) => { this.units = data || []; });
      });
    },
    removeUnit(data) {
      this.$Confirm('确认删除该计量单位？').then(() => {
        this.$api.pro.inventory.unitDel(data.id).then(() => {
          this.units = this.units.filter(x => x.id !== data.id);
        });
      });
    },
    // ---------- 科目映射 ----------
    openMapping(data) {
      this.mappingForm = data ? Object.assign({}, data)
        : {mappingType: 1, targetId: null, subjectId: null, direction: 1};
      this.modal.mapping = true;
    },
    saveMapping() {
      if (!this.mappingForm.targetId || !this.mappingForm.subjectId) {
        this.$Message.warning('请选择存货/类别与科目');
        return;
      }
      this.$api.pro.inventory.mappingSave(this.mappingForm).then(() => {
        this.$Message.success('保存成功');
        this.modal.mapping = false;
        this.$api.pro.inventory.mappingList().then(({data}) => { this.mappings = data || []; });
      });
    },
    removeMapping(data) {
      this.$Confirm('确认删除该映射？').then(() => {
        this.$api.pro.inventory.mappingDel(data.id).then(() => {
          this.mappings = this.mappings.filter(x => x.id !== data.id);
        });
      });
    },
    // ---------- 规则配置 ----------
    saveRule() {
      Promise.all([
        this.$api.pro.inventory.configSave({key: 'numberRule', value: this.numberRule}),
        this.$api.pro.inventory.configSave({key: 'moduleConfig', value: this.moduleConfig})
      ]).then(() => this.$Message.success('配置已保存'));
    },
    // ---------- 工具 ----------
    download(name, content) {
      let blob = new Blob(['\ufeff' + content], {type: 'text/csv;charset=utf-8'});
      let url = URL.createObjectURL(blob);
      let a = document.createElement('a');
      a.href = url;
      a.download = name;
      a.click();
      URL.revokeObjectURL(url);
    }
  },
  mounted() {
    this.loadAll();
  }
};
</script>

<style lang="less" scoped>
.margin-bottom {
  margin-bottom: 10px;
}
.link {
  color: #2d8cf0;
  cursor: pointer;
  margin: 0 5px;
  &.danger {
    color: #ed4014;
  }
}
</style>
